export default `int main()
{
    constexpr I am = "C++"_er;
    constexpr I like = C++;
    constexpr I love = C++;
}`;